import { useState } from 'react';

/**
 * LogoImage — shared logo with SVG fallback.
 * If logo.png is missing, renders the JNF crescent SVG.
 */
export default function LogoImage({ size = 64, className = '' }) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <svg
        width={size} height={size}
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-label="JNF Logo"
      >
        <circle cx="50" cy="50" r="48" fill="#1a1a6e" stroke="#1eb5e8" strokeWidth="3" />
        <path d="M50 18 A32 32 0 1 1 50 82 A22 22 0 1 0 50 18Z" fill="#1eb5e8" />
        <polygon
          points="50,24 53,34 63,34 55,40 58,51 50,45 42,51 45,40 37,34 47,34"
          fill="#1eb5e8" stroke="#1a1a6e" strokeWidth="1"
        />
      </svg>
    );
  }

  return (
    <img
      src="/logo.png"
      alt="JNF"
      width={size} height={size}
      className={className}
      style={{ width: size, height: size }}
      onError={() => setFailed(true)}
    />
  );
}
